<template>
  <ResultDetail />
</template>

<script>
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'

const ResultDetail = () => ({
  component: import('@/components/center_widgets/ResultDetail'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'ResultPage',
  components: { ResultDetail },
}
</script>
